import * as bs58check from 'bs58check';

export default function checkBs58(str: string): boolean {
  try {
    bs58check.decode(str);
    return true;
  } catch (err) {
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/util/checkBs58.ts